import { createAction } from 'typesafe-actions';
import { ApiGatewayResponseError } from './types';

export const apiGatewayActions = {
  requestError: createAction(
    '@apiGateway/REQUEST_ERROR',
    action => (status: number, response: ApiGatewayResponseError) => action({ status, response })
  )
};
